define('core/linter-rules/local-refs-exist',["exports", "core/l10n", "core/LinterRule"], function (exports, _l10n, _LinterRule) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.rule = undefined;

  var _LinterRule2 = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  const name = "local-refs-exist";

  const meta = {
    en: {
      description: "Broken local reference found in document.",
      howToFix: "Please fix the links mentioned.",
      help: "See developer console."
    }
  };

  // Fall back to english, if language is missing
  const lang = _l10n.lang in meta ? _l10n.lang : "en";

  /**
   * Runs linter rule.
   * @param {Object} config The ReSpec config.
   * @param  {Document} doc The document to be checked.
   */
  function linterFunction(conf, doc) {
    const offendingElements = [...doc.querySelectorAll("a[href^='#']")].filter(isBrokenHyperlink);
    if (!offendingElements.length) {
      return [];
    }
    return _extends({
      name,
      offendingElements,
      occurrences: offendingElements.length
    }, meta[lang]);
  }

  const rule = exports.rule = new _LinterRule2.default(name, linterFunction);

  function isBrokenHyperlink(elem) {
    const { href, ownerDocument: doc } = elem;
    const { hash } = new URL(href);
    return !doc.getElementById(hash.substring(1));
  }
});
//# sourceMappingURL=local-refs-exist.js.map;
